const lang = {
    "Kep": "QES",
    "KepNotLinked": "su firma cualificada aún no está vinculada a una cuenta. Inicie sesión como siempre y la vincularemos.",
    "KepNewAccount": "¿No tiene cuenta? Regístrese",
    "KepLinked": "Firma cualificada vinculada a la cuenta",
    "KepLinkFailed": "No se pudo vincular la firma cualificada. Inicie sesión con ella de nuevo y la vincularemos",
    "KepFile": "Archivo de clave",
    "ErrorKepLogin": "No se pudo iniciar sesión con la firma cualificada",
    "EnterWidth": "Iniciar con:",
    "Registration": "Registro",
    "enter": "Entrar",
    "EntrWidthEmailOrPhone": "Iniciar sesión con correo electrónico o teléfono",
    "login": "Autorización",
    "NoAkkGoReg": "Registro",
    "Password": "Clave",
    "Name": "Nombre",
    "LastName": "Apellido",
    "Phone": "Para registrarse, ingrese su número de teléfono",
    "Email": "Correo",
    "RepeatPassword": "repite la contraseña",
    "Сancel": "Cancelar",
    "Save": "Guardar",
    "Language": "Idioma",
    "ConfirmThisMail": "Tu correo ha sido confirmado",
    "Saved": "Salvado",
    "Error": "Error",
    "FillInAllTheFields": "Rellena todos los campos",
    "Next": "Más lejos",
    "MinPassLength": "Longitud mínima de la contraseña 4 caracteres",
    "ForgotYourPassword": "Olvidaste tu contraseña",
    "RestorePassword": "Por favor, establezca una nueva contraseña.",
    "UserMustBeRegistered": "El usuario debe estar registrado",
    "Confirm": "Confirmar",
    "WrongFormat": "Formato erróneo",
    "WrongPassword": "Contraseña incorrecta",
    "WrongLoginOrPassword": "Usuario o contraseña incorrectos",
    "PhoneAlreadyRegistered": "Teléfono ya registrado",
    "EmailAlreadyRegistered": "Correo ya registrado",
    "FillInTheFieldsCorrectly": "Rellena correctamente los campos",
    "ThisAccountDoesNotExist": "Esta cuenta no existe",
    "LinkIsNotValid": "El enlace no es válido",
    "AMessageHasBeenSentToTheSpecifiedLogin": "Se ha enviado un mensaje al nombre de usuario especificado",
    "IncorrectCaptcha": "Captcha incorrecto",
    "CaptchaIsNotValid": "El captcha ya no es válido",
    "EnterCaptcha": "Introduzca captcha",
    "EnterSMS": "Ingrese el código de SMS",
    "SMSCodeIsNoLongerValid": "El código SMS ya no es válido",
    "SMSCodeIsIncorrect": "El código SMS es incorrecto",
    "MailNotVerifiedLinkTimedOut": "Correo no confirmado, enlace caducado",
    "DemoLogin": "Inicio de sesión de demostración",
    "AreYouSureYouWantToEnterTheDemoForEvaluation": "¿Seguro que quieres entrar en la <b> demo </b> para probarlo?",
    "FillInAdditionalInformation": "Complete la información adicional",
    "ToCompleteRegistration": "Para completar el registro",
    "LinkThirdPartyServices": "Vincular servicios de terceros",
    "Complete": "Completar",
    "AccountAlreadyLinked": "Cuenta ya vinculada",
    "AccountNotRegistered": "Cuenta no registrada",
    "NotMyNumber": "no es mi numero",
    "Back": "Atrás",
    "numberOfAttemptsToCheckAuth": "Número de intentos de inicio de sesión:",
    "InvalidPassNumberOfAttemptsToCheckAuth": "Contraseña incorrecta, número de intentos de inicio de sesión:",
    "TryAgainAfterMinute": "Por favor, inténtelo de nuevo en 2 minutos.",
    "Help": "Apoyo",
    "y": "Sí",
    "n": "No",
    "doYouConfirmEmail": "¿Estás seguro de que quieres cambiar tu correo electrónico?",
    "success": "Exitosamente",
    "goToAutorize": "Ir a autorización",
    "UserEmailAlreadyExists": "El usuario con este correo electrónico ya existe",
    "UserPhoneAlreadyExists": "El usuario con este número de teléfono ya existe",
    "TermOfUse": "Términos de Uso",
    "PrivacyPolicy": "Política de privacidad",
    "accountNotRegistered": "cuenta no registrada",
    "wantToReg": "¿Le gustaría registrarse?",
    "weSuccessChangeYouEmail": "Hemos cambiado con éxito su dirección de correo electrónico",
    "youCanCloseThisWindow": "Puedes cerrar esta ventana",
    "countryConfirm": "Confirmación de país",
    "EmailAlreadyTied": "El correo ya está vinculado a otra cuenta",
    "areYourCountry": "¿Es este tu país?",
    "EmergencyEntrance": "Autorización antigua",
    "enterCorrectNumber": "Ingrese el número en formato internacional",
    "thisPhoneRegister": "Este número de teléfono ya está registrado en el sistema",
    "wantUsePhoneForAuth": "¿Te gustaría iniciar sesión con este número de teléfono?",
    "ok": "bien",
    "regAgree": "Al registrar una cuenta, acepto",
    "wantBind": "Quiere iniciar sesión y vincular el servicio",
    "bind": "unir",
    "yoursMailBinded": "Su correo electrónico está en una cuenta existente",
    "wantUsePhoneAndBind": "ya registrado en el sistema",
    "notGetDataFromApple": "No se pudieron recibir datos de Apple",
    "ErrorAppleLogin": "Error al autorizar a través de Apple",
    "ErrorGoogleLogin": "Error al autorizar a través de Google",
    "ErrorTelegramLogin": "Error al iniciar sesión a través de Telegram",
    "ErrorFacebookLogin": "Error al iniciar sesión a través de Facebook",
    "EMailOrPhone": "Ingrese un número de teléfono o dirección de correo electrónico válidos.",
    "withoutName": "Sin nombre",
    "goToCabinet": "A la oficina",
    "Logout": "Finalizar sesión",
    "creationDate": "Fecha de creación",
    "preparingCompany1": "Estamos creando tu empresa, por favor danos un minuto...",
    "preparingCompany2": "Estamos preparando una interfaz para gestionar bienes y servicios...",
    "preparingCompany3": "Estamos trabajando en una contabilidad financiera conveniente...",
    "preparingCompany4": "Estamos haciendo los ajustes finales, casi listo...",
    "companyBlocked": "Esta empresa está inactiva",
    "youBlockedInComp": "El usuario no está activo, no es posible iniciar sesión",
    "loginTitle": "Todo lo que una empresa necesita en un solo lugar",
    "loginDescr": "Automatización para tiendas, cafeterías, servicios de reparto, restaurantes, almacenes, producción o servicios.",
    "NoAkkGoRegText": "¿No tienes una cuenta?",
    "LoginPlaceholder": "Por favor proporcione la información requerida",
    "loginText": "¿Ya tienes una cuenta?",
    "and": "Y",
    "AcceptTheTerms": "Por favor acepte la política de privacidad y términos de uso",
    "CountryPhoneFormat": "Si este no es tu país, verifica que hayas ingresado tu número de teléfono en el formato internacional correcto.",
    "SaveNewPassword": "Guardar nueva contraseña"
}

export default function() {
    return lang;
}